module.exports = __webpack_public_path__ + "img/password-recovery.ea1a5dbf.png";